// src/routes/Disclaimer.jsx
import ContentPage from "@/components/content/ContentPage";

const Disclaimer = () => <ContentPage docKey="disclaimer" placeholder />;

export default Disclaimer;
